import CobranzaShow from './CobranzaShow'
export {CobranzaShow}
export default CobranzaShow
